import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as LimitsActions from './limits.actions';
import { Store } from '@ngrx/store';
import { catchError, concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';
import { getAccountListConfig } from '../account/account.selectors';
import { LimitsTemplate } from './../../../app/@shared/models/limits';
import { getDefault } from './limits.selectors';
import { loginSuccess } from '../auth/auth.actions';

@Injectable()
export class LimitsEffects {
  constructor(private readonly actions$: Actions, private readonly store: Store, private readonly apiPublic: PublicPartnerApiService) { }

  loadLimits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LimitsActions.loadLimits, loginSuccess, LimitsActions.patchLimitsSuccess),
      withLatestFrom(this.store.select(getAccountListConfig)),
      concatMap(
        action =>
          this.apiPublic.get<{ templates_resource_limits: Partial<Omit<LimitsTemplate, 'values'>>[] }>('/partners/##CURRENT_PARTNER_UUID##/templates_resource_limits', {}).pipe(
            map((result) => {
              return LimitsActions.loadLimitsSuccess({
                limits: result.templates_resource_limits
              });
            }),
            catchError(error => of(LimitsActions.loadLimitsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  patchLimits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LimitsActions.patchLimits),
      concatMap(
        action =>
          this.apiPublic.patch<void>('/partners/##CURRENT_PARTNER_UUID##/templates_resource_limits/' + action.limits_template_uuid, action.data).pipe(
            map(() => {
              return LimitsActions.patchLimitsSuccess({
                limits_template_uuid: action.limits_template_uuid
              });
            }),
            catchError(error => of(LimitsActions.patchLimitsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  loadLimitsDefaults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LimitsActions.loadLimitsSuccess),
      withLatestFrom(this.store.select(getDefault)),
      filter(([action, defaultLimit]) => defaultLimit !== undefined),
      concatMap(([action, defaultLimit]) => {
        return this.apiPublic.get<{ template_resource_limits: Partial<LimitsTemplate> }>('/partners/##CURRENT_PARTNER_UUID##/templates_resource_limits/' + defaultLimit!.object_uuid).pipe(
          map((result) => {
            return LimitsActions.loadDefaultLimitsSuccess({
              limits: result.template_resource_limits
            });
          }),
          catchError(error => of(LimitsActions.loadDefaultLimitsFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );
}
